// ** Initial State
const initialState = {
  allData: [],
  dropdownFormatted: [],
  data: [],
  total: 1,
  params: {},
  selectedCompany: null
}

const companies = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_COMPANIES':
      return { ...state, 
        allData: action.data,
        dropdownFormatted: action.data.map(item => ({
          label: item.company_name,
          value: item.id,
        })) 
      }
    case 'FILTER_ALL_COMPANIES':
      return {
        ...state,
        data: action.data,
        total: action.totalRecords,
        params: action.params
      }
    case 'GET_COMPANY':
      return { ...state, selectedCompany: action.selectedCompany }
    case 'ADD_COMPANY':
      return { ...state }
    case 'DELETE_COMPANY':
      return { ...state }
    default:
      return { ...state }
  }
}
export default companies
